export default __webpack_public_path__ + "static/media/bux_sme.589ff4d3.svg";